<template>
  <div class="main order">
    <div class="nav">
      <div class="left">
        <div class="front icon_back" @click="rtunblack()"></div>
      </div>
      确认订单
    </div>
    <div style="overflow: scroll">
      <div class="order-list">
        <div class="left">
          <div class="front icon_locat"></div>
          <div>
            <div class="order-add">
              <div
                v-if="loctdz.is_default == 1 && spid == undefined"
                @click="addloct()"
              >
                <p class="add-mine">
                  <span>{{ loctdz.name }}</span>
                  <span>{{ loctdz.phone }}</span>
                </p>
                <p>
                  {{ loctdz.province }} {{ loctdz.city }} {{ loctdz.address }}
                </p>
              </div>
              <div v-if="loctdz && spid" @click="addloct()">
                <p class="add-mine">
                  <span>{{ spid.name }}</span>
                  <span>{{ spid.phone }}</span>
                </p>
                <p>{{ spid.province }} {{ spid.city }} {{ spid.address }}</p>
              </div>
            </div>
            <div
              class="order-add"
              v-if="
                Object.keys(InfoaddressList).length < 0 ||
                (JSON.stringify(loctdz) == '{}' && spid == undefined)
              "
              @click="addloct1()"
            >
              暂无地址，请前往添加地址
            </div>
          </div>
        </div>
        <div
          class="img-more"
          v-if="loctdz.is_default == 1 && spid == undefined"
          @click="addloct()"
        >
          <img src="../assets/images/more.png" alt="" />
        </div>
        <div class="img-more" v-if="loctdz && spid" @click="addloct()">
          <img src="../assets/images/more.png" alt="" />
        </div>
        <div
          class="img-more"
          v-if="
            Object.keys(InfoaddressList).length < 0 ||
            (JSON.stringify(loctdz) == '{}' && spid == undefined)
          "
          @click="addloct()"
        >
          <img src="../assets/images/more.png" alt="" />
        </div>
      </div>
      <div class="order-all">
        <div class="order-num">
          <div class="img-text">
            <div class="left-img">
              <img :src="detaildec.img" alt="" />
            </div>
            <div class="min-text">{{ detaildec.title }}</div>
            <div class="right-money" v-if="detaildec && detaildec.discountPriceInfo">
              <span>¥</span> {{ detaildec.discountPriceInfo[0].vipAmount }}
            </div>
          </div>
        </div>
        <div class="all-num">
          <div>购买数量</div>
          <van-stepper
            v-model="value"
            min="1"
            :max="detaildec.limit_stock"
            @change="change(value)"
          />
        </div>
        <div class="input">
          <van-field
            v-model="value1"
            label="订单备注"
            placeholder="选填，请联系商家"
            maxlength="30"
          />
        </div>
        <div>
          <div class="all-count">
            <span>共{{ value }}件</span><span>小计：</span
            ><span>¥ {{ commodityprice }}</span>
          </div>
        </div>
      </div>
      <!-- <div
        class="discount"
        v-if="detaildec && detaildec.discount && detaildec.discount.description"
      >
        <div class="left">
          <img src="../assets/images/discount.png" alt="" />
        </div>
        <div>{{ detaildec.discount.description }}</div>
      </div> -->
    </div>
    <div class="submit-bar">
      <div class="submit-bar-bar">
        <div
          class="submit-bar-text"
          v-if="detaildec && detaildec.discount && detaildec.discount.discount"
        >
          <span>共{{ value }}件</span><span>小计：</span
          ><span
            >¥
            {{ commodityprice }}
            </span
          >
        </div>
        <div class="submit-bar-text" v-else>
          <span>共{{ value }}件</span><span>小计：</span
          ><span>¥{{ commodityprice }} </span>
        </div>
        <div class="submit-bar-btn" @click="qqq(detaildec)">提交订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Toast, Stepper, Field } from "vant";
Vue.use(Toast).use(Stepper).use(Field);
export default {
  data() {
    return {
      InfoaddressList: {},
      loctdz: {},
      spid: {},
      receipt: "",
      value: 1,
      value1: "",
      detaildec: {},
      commodityprice: 1,
    };
  },
  computed: {
    ...mapState(["homePage"]),
    ...mapState("homePage", ["Syssetting"]),
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations("homePage", ["setSyssetting"]),
    addloct() {
      let obj = {
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
        goodsId: this.queryData.goodsId,
      };
      this.$router.push({
        path: "/selfInfo",
        name: "selfInfo",
        query: obj,
        params: {
          status: 1,
          acount: this.value,
        },
      });
    },
    addloct1(){
            let obj = {
              userId: this.queryData.userId,
              appId: this.queryData.appId,
              uid: this.queryData.uid,
              goodsId: this.queryData.goodsId,
            };
            this.$router.push({
              path: "/address",
              name: "address",
              query: obj,
              params: {
                status: 2,
                acount: this.value,
              },
            });
    },
    rtunblack() {
      this.$router.push({
        path: "/prodetails",
        name: "prodetails",
        query: this.queryData,
        params: {
          acount: this.value,
        },
      });
    },
    qqq(detaildec) {
      // console.log(detaildec.priceInfo)
      if (this.loctdz.is_default == 1 && this.spid == undefined) {
        // console.log(this.loctdz.id)
        // console.log(1)
        let obj = {
          goodsId: detaildec.id,
          userId: this.queryData.userId,
          appId: this.queryData.appId,
          addresssId: this.loctdz.id,
          uid: this.queryData.uid,
          goods_num: this.value,
          remark: this.value1,
        };
        // let data = detaildec.priceInfo;
        // for (let k in data) {
        //   data[k];
        if (detaildec && detaildec.discount && detaildec.discount.discount) {
          //  console.log(2)
          this.$dialog
            .confirm({
              title: "兑换提醒",
              message:
                "确定使用" +
                this.numFilter(
                  this.commodityprice
                ) +
                "金币兑换 " +
                detaildec.title +
                " 吗？",
            })
            .then(() => {
              this.$store
                .dispatch("homePage/fetchGoodsExchange", obj)
                .then((res) => {
                  if (res.code == 200) {
                    // sa.track("Commodity", {
                    //   product_id: res.data.unprice.id,
                    // });
                    // sa.track("Consume", {
                    //   amount: res.data.unprice.amount,
                    // });
                    this.$dialog({
                      title: "兑换提醒",
                      message: "兑换奖品成功",
                    }).then(() => {
                      this.sensors.track(
                        "ExchangeCommodity",
                        {
                          app_number: this.queryData.apptype,
                          mall_commodity_id: res.data.unprice.id,
                        },
                        () => {
                          console.log("success");
                        }
                      );
                      if (window && window.AndroidClient) {
                        let params = {
                          amount: res.data.unprice.amount,
                          mall_commodity_id: res.data.unprice.id,
                        };
                        window.AndroidClient.callBackAfterFinishOrder(
                          JSON.stringify(params)
                        );
                      }
                      if (
                        window &&
                        window.webkit &&
                        window.webkit.messageHandlers
                      ) {
                        let params = {
                          amount: res.data.unprice.amount, //商品消耗金币
                          mall_commodity_id: res.data.unprice.id, //商品id
                        };
                        window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
                          params
                        );
                      }
                    });
                    this.$router.push({
                      path: "/",
                      query: {
                        userId: this.queryData.userId,
                        appId: this.queryData.appId,
                        uid: this.queryData.uid,
                        apptype: this.queryData.apptype,
                      },
                    });
                    // this.$store.dispatch("homePage/fetchHome", obj);
                    // this.$store.dispatch("homePage/fetchProductList", obj);
                    // let jx = {
                    //   userId: this.queryData.userId,
                    //   appId: this.queryData.appId,
                    //   uid: this.queryData.uid,
                    //   is_chosen: 1,
                    //   pageSize: 999,
                    // };
                    // this.$store.dispatch("homePage/fetchChosenList", jx);
                  } else {
                    // this.$dialog({
                    //   title: "兑换提醒",
                    //   message: res.msg,
                    // });
                    console.log(res.msg);
                    if (res.msg == "消耗物品不足！") {
                      Toast({
                        message: "金币不足无法兑换！",
                      });
                    } else {
                      Toast({
                        message: res.msg,
                      });
                    }
                  }
                });
            });
        } else {
          this.$dialog
            .confirm({
              title: "兑换提醒",
              message:
                "确定使用" +
                this.commodityprice +
                "金币兑换 " +
                detaildec.title +
                " 吗？",
            })
            .then(() => {
              this.$store
                .dispatch("homePage/fetchGoodsExchange", obj)
                .then((res) => {
                  if (res.code == 200) {
                    // sa.track("Commodity", {
                    //   product_id: res.data.unprice.id,
                    // });
                    // sa.track("Consume", {
                    //   amount: res.data.unprice.amount,
                    // });
                    this.$dialog({
                      title: "兑换提醒",
                      message: "兑换奖品成功",
                    }).then(() => {
                      this.sensors.track(
                        "ExchangeCommodity",
                        {
                          app_number: this.queryData.apptype,
                          mall_commodity_id: res.data.unprice.id,
                        },
                        () => {
                          console.log("success");
                        }
                      );
                      if (window && window.AndroidClient) {
                        let params = {
                          amount: res.data.unprice.amount,
                          mall_commodity_id: res.data.unprice.id,
                        };
                        window.AndroidClient.callBackAfterFinishOrder(
                          JSON.stringify(params)
                        );
                      }
                      if (
                        window &&
                        window.webkit &&
                        window.webkit.messageHandlers
                      ) {
                        let params = {
                          amount: res.data.unprice.amount, //商品消耗金币
                          mall_commodity_id: res.data.unprice.id, //商品id
                        };
                        window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
                          params
                        );
                      }
                    });
                    this.$router.push({
                      path: "/",
                      query: {
                        userId: this.queryData.userId,
                        appId: this.queryData.appId,
                        uid: this.queryData.uid,
                        apptype: this.queryData.apptype,
                      },
                    });
                    // this.$store.dispatch("homePage/fetchHome", obj);
                    // this.$store.dispatch("homePage/fetchProductList", obj);
                    // let jx = {
                    //   userId: this.queryData.userId,
                    //   appId: this.queryData.appId,
                    //   uid: this.queryData.uid,
                    //   is_chosen: 1,
                    //   pageSize: 999,
                    // };
                    // this.$store.dispatch("homePage/fetchChosenList", jx);
                  } else {
                    // this.$dialog({
                    //   title: "兑换提醒",
                    //   message: res.msg,
                    // });
                    console.log(res.msg);
                    if (res.msg == "消耗物品不足！") {
                      Toast({
                        message: "金币不足无法兑换！",
                      });
                    } else {
                      Toast({
                        message: res.msg,
                      });
                    }
                  }
                });
            });
        }
        // }
      }
      if (this.loctdz && this.spid) {
        // console.log(this.spid.id)
        let obj = {
          goodsId: detaildec.id,
          userId: this.queryData.userId,
          appId: this.queryData.appId,
          addresssId: this.spid.id,
          uid: this.queryData.uid,
          goods_num: this.value,
          remark: this.value1,
        };
        if (detaildec && detaildec.discount && detaildec.discount.discount) {
          this.$dialog
            .confirm({
              title: "兑换提醒",
              message:
                "确定使用" +
                this.numFilter(
                  this.commodityprice * (detaildec.discount.discount / 100)
                ) +
                "金币兑换 " +
                detaildec.title +
                " 吗？",
            })
            .then(() => {
              this.$store
                .dispatch("homePage/fetchGoodsExchange", obj)
                .then((res) => {
                  if (res.code == 200) {
                    // sa.track("Commodity", {
                    //   product_id: res.data.unprice.id,
                    // });
                    // sa.track("Consume", {
                    //   amount: res.data.unprice.amount,
                    // });
                    this.$dialog({
                      title: "兑换提醒",
                      message: "兑换奖品成功",
                    }).then(() => {
                      this.sensors.track(
                        "ExchangeCommodity",
                        {
                          app_number: this.queryData.apptype,
                          mall_commodity_id: res.data.unprice.id,
                        },
                        () => {
                          console.log("success");
                        }
                      );
                      if (window && window.AndroidClient) {
                        let params = {
                          amount: res.data.unprice.amount,
                          mall_commodity_id: res.data.unprice.id,
                        };
                        window.AndroidClient.callBackAfterFinishOrder(
                          JSON.stringify(params)
                        );
                      }
                      if (
                        window &&
                        window.webkit &&
                        window.webkit.messageHandlers
                      ) {
                        let params = {
                          amount: res.data.unprice.amount, //商品消耗金币
                          mall_commodity_id: res.data.unprice.id, //商品id
                        };
                        window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
                          params
                        );
                      }
                    });
                    this.$router.push({
                      path: "/",
                      query: {
                        userId: this.queryData.userId,
                        appId: this.queryData.appId,
                        uid: this.queryData.uid,
                        apptype: this.queryData.apptype,
                      },
                    });
                    // this.$store.dispatch("homePage/fetchHome", obj);
                    // this.$store.dispatch("homePage/fetchProductList", obj);
                    // let jx = {
                    //   userId: this.queryData.userId,
                    //   appId: this.queryData.appId,
                    //   uid: this.queryData.uid,
                    //   is_chosen: 1,
                    //   pageSize: 999,
                    // };
                    // this.$store.dispatch("homePage/fetchChosenList", jx);
                  } else {
                    // this.$dialog({
                    //   title: "兑换提醒",
                    //   message: res.msg,
                    // });
                    console.log(res.msg);
                    if (res.msg == "消耗物品不足！") {
                      Toast({
                        message: "金币不足无法兑换！",
                      });
                    } else {
                      Toast({
                        message: res.msg,
                      });
                    }
                  }
                });
            });
        } else {
          this.$dialog
            .confirm({
              title: "兑换提醒",
              message:
                "确定使用" +
                this.commodityprice +
                "金币兑换 " +
                detaildec.title +
                " 吗？",
            })
            .then(() => {
              this.$store
                .dispatch("homePage/fetchGoodsExchange", obj)
                .then((res) => {
                  if (res.code == 200) {
                    // sa.track("Commodity", {
                    //   product_id: res.data.unprice.id,
                    // });
                    // sa.track("Consume", {
                    //   amount: res.data.unprice.amount,
                    // });
                    this.$dialog({
                      title: "兑换提醒",
                      message: "兑换奖品成功",
                    }).then(() => {
                      this.sensors.track(
                        "ExchangeCommodity",
                        {
                          app_number: this.queryData.apptype,
                          mall_commodity_id: res.data.unprice.id,
                        },
                        () => {
                          console.log("success");
                        }
                      );
                      if (window && window.AndroidClient) {
                        let params = {
                          amount: res.data.unprice.amount,
                          mall_commodity_id: res.data.unprice.id,
                        };
                        window.AndroidClient.callBackAfterFinishOrder(
                          JSON.stringify(params)
                        );
                      }
                      if (
                        window &&
                        window.webkit &&
                        window.webkit.messageHandlers
                      ) {
                        let params = {
                          amount: res.data.unprice.amount, //商品消耗金币
                          mall_commodity_id: res.data.unprice.id, //商品id
                        };
                        window.webkit.messageHandlers.callBackAfterFinishOrder.postMessage(
                          params
                        );
                      }
                    });
                    this.$router.push({
                      path: "/",
                      query: {
                        userId: this.queryData.userId,
                        appId: this.queryData.appId,
                        uid: this.queryData.uid,
                        apptype: this.queryData.apptype,
                      },
                    });
                    // this.$store.dispatch("homePage/fetchHome", obj);
                    // this.$store.dispatch("homePage/fetchProductList", obj);
                    // let jx = {
                    //   userId: this.queryData.userId,
                    //   appId: this.queryData.appId,
                    //   uid: this.queryData.uid,
                    //   is_chosen: 1,
                    //   pageSize: 999,
                    // };
                    // this.$store.dispatch("homePage/fetchChosenList", jx);
                  } else {
                    // this.$dialog({
                    //   title: "兑换提醒",
                    //   message: res.msg,
                    // });
                    console.log(res.msg);
                    if (res.msg == "消耗物品不足！") {
                      Toast({
                        message: "金币不足无法兑换！",
                      });
                    } else {
                      Toast({
                        message: res.msg,
                      });
                    }
                  }
                });
            });
        }
      }
      if (JSON.stringify(this.loctdz) == "{}" &&  this.spid == undefined) {
        // console.log(this.loctdz)
        // console.log(1);
        this.$dialog
          .confirm({
            title: "添加地址提醒",
            message: "此物品需要添加地址",
          })
          .then(() => {
            let obj = {
              userId: this.queryData.userId,
              appId: this.queryData.appId,
              uid: this.queryData.uid,
              goodsId: this.queryData.goodsId,
            };
            this.$router.push({
              path: "/address",
              name: "address",
              query: obj,
              params: {
                status: 2,
                acount: this.value,
              },
            });
          });
      }
    },
    change(value) {
      //   console.log(this.value);
      this.commodityprice = value * this.detaildec.discountPriceInfo[0].vipAmount;
      console.log(this.commodityprice)
      // console.log(this.commodityprice * 0.9)
    },
    numFilter(s) {
      let realVal = parseFloat(s).toFixed(2);
      return realVal;
    },
  },
  //   filters: {
  //     numFilter(s) {
  //       let realVal = parseFloat(s).toFixed(2);
  //       return realVal;
  //     },
  //   },
  created() {
    //   console.log(this.loctdz)
    this.spid = this.$route.params.aidlist;
    // console.log(this.spid)
    this.value = this.$route.params.allcount;
    // console.log(this.spid);
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      userId: this.queryData.userId,
      appId: this.queryData.appId,
      uid: this.queryData.uid,
    };
    this.$store.dispatch("homePage/fetchAddressList", obj).then((res) => {
      this.InfoaddressList = res.data;
      // console.log(this.InfoaddressList);
      // if(this.InfoaddressList != "{}"){
      for (var i = 0; i < Object.keys(this.InfoaddressList).length; i++) {
        if (this.InfoaddressList[i].is_default == 1) {
          this.loctdz = this.InfoaddressList[i];
          //   console.log(this.loctdz)
        }
      }
      // }
    });
    let goods = {
      userId: this.queryData.userId,
      goodsId: this.queryData.goodsId,
      appId: this.queryData.appId,
    };
    this.$store.dispatch("homePage/fetchGoodsDetail", goods).then((res) => {
      this.detaildec = res;
      // console.log(this.detaildec.discount.discount  / 100)
      if (this.detaildec.discountPriceInfo) {
        this.commodityprice = this.value * this.detaildec.discountPriceInfo[0].vipAmount;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
// .input{
//     line-height: inherit !important;
// }
.order {
  background: #f1f4f5;
  .nav {
    background: #fff;
  }
  .order-list {
    display: flex;
    background: #ffffff;
    padding: 20px 0;
    margin: 12px 8px;
    border-radius: 8px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    & > .left {
      margin-left: 15px;
      display: flex;
      align-items: center;
      .order-add {
        width: 280px;
        font-size: 12px;
        color: #222222;
        // line-height: 18px;
        margin-left: 8px;
      }
    }
    .img-more {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .add-mine {
      margin-bottom: 8px;
      span {
        font-size: 12px;
        color: #676767;
        &:nth-child(1) {
          color: #222222;
          font-size: 16px;
          margin-right: 8px;
        }
      }
    }
  }
  .order-all {
    border-radius: 8px;
    margin: 0 8px;
    padding: 16px 0;
    background: #ffffff;
    .order-num {
      display: flex;
      background: #ffffff;
      // border-radius: 8px;
      // margin: 0 8px;
      // padding: 16px 0;
      color: #1e1e1e;
      font-size: 14px;
      .img-text {
        margin: 0 8px;
        display: flex;
        .left-img {
          width: 84px;
          height: 84px;
          border-radius: 4px;
          img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 4px;
          }
        }
      }
      .min-text {
        width: 168px;
        margin: 0 5px 0 11px;
      }
      .right-money {
        width: 75px;
        text-align: right;
        span {
          font-size: 10px;
        }
      }
    }
    .all-num {
      display: flex;
      justify-content: space-between;
      /* margin-left: 30px; */
      margin: 25px 8px 25px 30px;
      color: #1e1e1e;
      font-size: 14px;
      align-items: center;
    }
    .input {
      margin-left: 14px;
    }
    .all-count {
      font-size: 14px;
      color: #1e1e1e;
      text-align: right;
      margin: 0 8px;
      span {
        &:nth-child(1) {
          color: #a6a6a6;
          font-size: 12px;
          margin-right: 10px;
        }
        &:nth-child(3) {
          color: #eb5428;
        }
      }
    }
  }
  .discount {
    display: flex;
    margin: 12px 8px 0 8px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #ddb87a;
    font-size: 12px;
    color: #eb5428;
    align-items: center;
    padding: 8px 0;
    .left {
      margin: 0 5px 0 12px;
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .submit-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    background: #ffffff;
    .submit-bar-bar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 56px;
      padding: 0 16px;
      font-size: 14px;
      .submit-bar-text {
        flex: 1;
        padding-right: 12px;
        color: #323233;
        text-align: right;
        span {
          &:nth-child(1) {
            color: #a6a6a6;
            font-size: 12px;
            margin-right: 10px;
          }
          &:nth-child(3) {
            color: #eb5428;
          }
        }
      }
      .submit-bar-btn {
        border-radius: 24px;
        background: linear-gradient(90deg, #f2a333 0%, #ed7633 100%);
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
}
</style>